module.exports = __webpack_public_path__ + "static/media/ico_delete_o.7ec354a0.svg";